import { getPath } from '@/router/common'

const baseUrl = {
  title: '明细',
  path: 'newCW_Detail'
}

export default [
  {
    path: getPath('Detail', baseUrl),
    name: 'newCW_Detail_Detail',
    component: () => import(/* webpackChunkName: "newCW_Detail_Detail" */ '@/views/newCW_Detail/detail/index.vue'),
    meta: {
      title: '明细|应收应付明细'
    }
  }
]
